import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#0D1B2A] text-white">
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 rounded-full bg-[#D4AF37] animate-pulse" />
          <div className="text-sm uppercase tracking-[0.22em] text-white/70">Loading admin</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
